<template>
  <v-data-table :headers="changeCategoriesHeaders" :items="filteredItems" style="border: solid 1px;" :show-select="showSelect" :sort-by="[{ key: 'name', order: 'asc' }]">
    <template v-slot:top>
      <v-row dense class="px-3">
        <v-col cols="12">
          <v-autocomplete
            :items="facilitators"
            item-title="displayName"
            item-value="id"
            return-object
            label="Search by facilitator"
            variant="underlined"
            hide-no-data
            v-model="searchFacilitator"
            hide-selected
            clearable
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row justify="end" dense>
        <v-col cols="12" sm="3" class="py-0 mr-3" style="display: flex; justify-content: flex-end">
          <div v-if="showSelect">
            <v-btn small color="green" class="white--text mr-2" @click="next()"><v-icon>mdi-check</v-icon>Continue</v-btn>
            <v-btn small color="red" class="white--text" @click="cancel"><v-icon>mdi-close</v-icon>Cancel</v-btn>
          </div>
          <v-menu top close-on-click v-if="readonly ? false : !showSelect">
            <template v-slot:activator="{ props }">
              <v-btn color="primary" class="white-text" small v-bind="props">
                Bulk Actions <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="addTasks">
                <v-list-item-title>Add Tasks</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </template>
    <template v-slot:header.data-table-select="{ on, props }">
      <v-checkbox
        color="green"
        :model-value="selected && selected.length === 0 ? false : selected && filteredItems.length === selected.length"
        @update:modelValue="onMultiSelectChange($event)"
        :indeterminate="selected && selected.length > 0 && filteredItems.length !== selected.length"
      ></v-checkbox>
    </template>
    <template v-slot:item="props">
      <tr>
        <td v-if="showSelect">
          <v-checkbox
            color="green"
            :model-value="props.item.isSelected"
            hide-details
            @update:modelValue="onItemCheckboxChange($event, props.item)"
          ></v-checkbox>
        </td>
        <td>
          <a @click="editChangeCategory(props.item)" class="blue-link">{{ props.item.name }}</a>
        </td>
        <td>{{ props.item.facilitator ? props.item.facilitator.displayName : '' }}</td>
        <td>{{ props.item.backupFacilitator ? props.item.backupFacilitator.displayName : '' }}</td>
        <td>{{ (props.item.approvalProcessTypes || []).length }}</td>
        <td>{{ (props.item.mocTypes || []).length }}</td>
        <td>{{ props.item.displayOrder }}</td>
        <td>{{ props.item.enabled ? 'Yes' : 'No' }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'ChangeCategoryTable',
  props: {
    changeCategories: Array,
    readonly: Boolean
  },
  data() {
    return {
      changeCategoriesHeaders: [
        {
          title: 'Name',
          key: 'name'
        },
        {
          title: 'Facilitator',
          key: 'facilitator.displayName'
        },
        {
          title: 'Backup',
          key: 'backupFacilitator.displayName'
        },
        {
          title: 'Approval Process Types',
          key: 'approvalProcessTypes.length'
        },
        {
          title: 'MOC Types',
          key: 'mocTypes.length'
        },
        {
          title: 'Display Order',
          key: 'displayOrder'
        },
        {
          title: 'Enabled',
          key: 'enabled'
        }
      ],
      searchFacilitator: undefined,
      showSelect: false,
      selected: [],
      next: () => {}
    }
  },
  computed: {
    facilitators() {
      const results = [];
      this.changeCategories.forEach(c => {
        if (!results.some(r => r.id === c.facilitator.id))
          results.push(c.facilitator)
      });
      return results;
    },
    filteredItems() {
      return this.changeCategories
        .filter(changeCategory =>
          this.searchFacilitator && this.searchFacilitator.id ? changeCategory.facilitator.id === this.searchFacilitator.id : true
        )
        .map(c => ({ ...c, isSelected: this.selected.findIndex(s => s.clientID === c.clientID) !== -1 }))
    }
  },
  methods: {
    onMultiSelectChange(value) {
      if (value) {
        this.selected = this.filteredItems
      } else {
        this.selected = []
      }
    },
    addTasks() {
      this.showSelect = true
      this.next = this.openFATDialog
    },
    openFATDialog() {
      this.showSelect = false
      this.$emit('openFAT', this.selected, 'changeCategory')
      this.selected = []
    },
    onItemCheckboxChange(value, item) {
      if (value) {
        this.selected.push(item)
      } else {
        this.selected = this.selected.filter(s => s.clientID !== item.clientID)
      }
    },
    editChangeCategory(item) {
      this.$emit('edit', item)
    },
    cancel() {
      this.selected = []
      this.showSelect = false
    }
  }
}
</script>
